import type { CSSProperties } from 'react';
import { Icon } from '@/components/foundations';

const HIDDEN: CSSProperties = { position: 'absolute', width: 1, height: 1, padding: 0, margin: -1, overflow: 'hidden', clip: 'rect(0 0 0 0)', whiteSpace: 'nowrap', border: 0 };

export type CopyToastProps = {
  /** Mostra (e anuncia) o "Copiado". */
  show: boolean;
  label?: string;
  /** `true` (padrão) = só para leitor de tela; o retorno visual do pacote é o ícone ficar verde. */
  visuallyHidden?: boolean;
};

/** Retorno "Copiado" dos campos de copiar. Use com `useCopy()` (`copied`). */
export function CopyToast({ show, label = 'Copiado', visuallyHidden = true }: CopyToastProps) {
  if (visuallyHidden) return <span role="status" style={HIDDEN}>{show ? label : ''}</span>;
  return (
    <span role="status">
      {show && <span className="badge ok"><Icon name="check" />{label}</span>}
    </span>
  );
}
